













import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";

import { Location } from "vue-router";
import Button from "@/shared/components/ui/Button.vue";

@Component({
  components: { Button }
})
export default class Finish extends Vue {
  @Prop()
  routeToFinish: () => Location;
}
